module.exports = __webpack_public_path__ + "static/media/Lato-BoldItalic.7b48d663.eot";